import React from 'react';
import withIcon from '../utilities/withIcon';

const IconClock = () => {
  return (
    <g>
      <path d="m8 .0874a7.9126 7.9126 0 1 0 7.9128 7.9126 7.9217 7.9217 0 0 0 -7.9128-7.9126zm0 14.3252a6.4126 6.4126 0 1 1 6.4128-6.4126 6.42 6.42 0 0 1 -6.4128 6.4126z" />
      <path d="m12.6746 9.896-3.9246-2.3243v-3.9917a.75.75 0 1 0 -1.5 0v4.42a.6964.6964 0 0 0 .0175.0865.7258.7258 0 0 0 .0308.1525.94.94 0 0 0 .14.2449.7266.7266 0 0 0 .1112.1.7083.7083 0 0 0 .068.0613l4.2925 2.5418a.75.75 0 0 0 .7646-1.291z" />
    </g>
  );
};

export default withIcon(IconClock);
